/**
 * JSIC 細分類カタログ (自動生成; 手で編集しない)。
 *
 * 出典: AutoDevJapan/GoDD-Design-Systems `jsic.json` の subclass (4桁細分類)。
 * 改定: 第14回改定 (令和5年7月告示)
 * 再生成: `node scripts/gen-jsic-catalog.mjs`
 *
 * 業種名 → JSIC コード解決 (src/axes/jsic.ts) の母集合。ここに無いコードは
 * 存在しないものとして扱い、捏造コードを禁ずる。
 */

/** JSIC 細分類の 1 エントリ (code と名称のみ)。 */
export interface JsicSubclass {
  /** JSIC 細分類コード (4桁)。 */
  readonly code: string;
  /** 細分類名称。 */
  readonly name: string;
}

/** JSIC 細分類の全件 (1473 件)。 */
export const JSIC_SUBCLASSES: readonly JsicSubclass[] = [
  { code: "0100", name: "主として管理事務を行う本社等" },
  { code: "0109", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "0111", name: "米作農業" },
  { code: "0112", name: "米作以外の穀作農業" },
  { code: "0113", name: "野菜作農業（きのこ類の栽培を含む）" },
  { code: "0114", name: "果樹作農業" },
  { code: "0115", name: "花き作農業" },
  { code: "0116", name: "工芸農作物農業" },
  { code: "0117", name: "ばれいしょ・かんしょ作農業" },
  { code: "0119", name: "その他の耕種農業" },
  { code: "0121", name: "酪農業" },
  { code: "0122", name: "肉用牛生産業" },
  { code: "0123", name: "養豚業" },
  { code: "0124", name: "養鶏業" },
  { code: "0125", name: "畜産類似業" },
  { code: "0126", name: "養蚕農業" },
  { code: "0129", name: "その他の畜産農業" },
  { code: "0131", name: "穀作サービス業" },
  { code: "0132", name: "野菜作･果樹作サービス業" },
  { code: "0133", name: "穀作、野菜作･果樹作以外の耕種サービス業" },
  { code: "0134", name: "畜産サービス業（獣医業を除く）" },
  { code: "0141", name: "園芸サービス業" },
  { code: "0200", name: "主として管理事務を行う本社等" },
  { code: "0209", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "0211", name: "育林業" },
  { code: "0221", name: "素材生産業" },
  { code: "0231", name: "製薪炭業" },
  { code: "0239", name: "その他の特用林産物生産業（きのこ類の栽培を除く）" },
  { code: "0241", name: "育林サービス業" },
  { code: "0242", name: "素材生産サービス業" },
  { code: "0243", name: "山林種苗生産サービス業" },
  { code: "0249", name: "その他の林業サービス業" },
  { code: "0299", name: "その他の林業" },
  { code: "0300", name: "主として管理事務を行う本社等" },
  { code: "0309", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "0311", name: "底びき網漁業" },
  { code: "0312", name: "まき網漁業" },
  { code: "0313", name: "刺網漁業" },
  { code: "0314", name: "釣・はえ縄漁業" },
  { code: "0315", name: "定置網漁業" },
  { code: "0316", name: "地びき網・船びき網漁業" },
  { code: "0317", name: "採貝・採藻業" },
  { code: "0318", name: "捕鯨業" },
  { code: "0319", name: "その他の海面漁業" },
  { code: "0321", name: "内水面漁業" },
  { code: "0400", name: "主として管理事務を行う本社等" },
  { code: "0409", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "0411", name: "魚類養殖業" },
  { code: "0412", name: "貝類養殖業" },
  { code: "0413", name: "藻類養殖業" },
  { code: "0414", name: "真珠養殖業" },
  { code: "0415", name: "種苗養殖業" },
  { code: "0419", name: "その他の海面養殖業" },
  { code: "0421", name: "内水面養殖業" },
  { code: "0500", name: "主として管理事務を行う本社等" },
  { code: "0509", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "0511", name: "金・銀鉱業" },
  { code: "0512", name: "鉛・亜鉛鉱業" },
  { code: "0513", name: "鉄鉱業" },
  { code: "0519", name: "その他の金属鉱業" },
  { code: "0521", name: "石炭鉱業（石炭選別業を含む）" },
  { code: "0522", name: "亜炭鉱業" },
  { code: "0531", name: "原油鉱業" },
  { code: "0532", name: "天然ガス鉱業" },
  { code: "0541", name: "花こう岩・同類似岩石採石業" },
  { code: "0542", name: "石英粗面岩・同類似岩石採石業" },
  { code: "0543", name: "安山岩・同類似岩石採石業" },
  { code: "0544", name: "大理石採石業" },
  { code: "0545", name: "ぎょう灰岩採石業" },
  { code: "0546", name: "砂岩採石業" },
  { code: "0547", name: "粘板岩採石業" },
  { code: "0548", name: "砂・砂利・玉石採取業" },
  { code: "0549", name: "その他の採石業、砂・砂利・玉石採取業" },
  { code: "0551", name: "耐火粘土鉱業" },
  { code: "0552", name: "ろう石鉱業" },
  { code: "0553", name: "ドロマイト鉱業" },
  { code: "0554", name: "長石鉱業" },
  { code: "0555", name: "けい石鉱業" },
  { code: "0556", name: "天然けい砂鉱業" },
  { code: "0557", name: "石灰石鉱業" },
  { code: "0559", name: "その他の窯業原料用鉱物鉱業" },
  { code: "0591", name: "酸性白土鉱業" },
  { code: "0592", name: "ベントナイト鉱業" },
  { code: "0593", name: "けいそう土鉱業" },
  { code: "0594", name: "滑石鉱業" },
  { code: "0599", name: "他に分類されない鉱業" },
  { code: "0600", name: "主として管理事務を行う本社等" },
  { code: "0609", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "0611", name: "一般土木建築工事業" },
  { code: "0621", name: "土木工事業(別掲を除く)" },
  { code: "0622", name: "造園工事業" },
  { code: "0623", name: "しゅんせつ工事業" },
  { code: "0631", name: "舗装工事業" },
  { code: "0641", name: "建築工事業(木造建築工事業を除く)" },
  { code: "0651", name: "木造建築工事業" },
  { code: "0661", name: "建築リフォーム工事業" },
  { code: "0700", name: "主として管理事務を行う本社等" },
  { code: "0709", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "0711", name: "大工工事業(型枠大工工事業を除く)" },
  { code: "0712", name: "型枠大工工事業" },
  { code: "0721", name: "とび工事業" },
  { code: "0722", name: "土工･コンクリート工事業" },
  { code: "0723", name: "特殊コンクリート工事業" },
  { code: "0731", name: "鉄骨工事業" },
  { code: "0732", name: "鉄筋工事業" },
  { code: "0741", name: "石工工事業" },
  { code: "0742", name: "れんが工事業" },
  { code: "0743", name: "タイル工事業" },
  { code: "0744", name: "コンクリートブロック工事業" },
  { code: "0751", name: "左官工事業" },
  { code: "0761", name: "金属製屋根工事業" },
  { code: "0762", name: "板金工事業" },
  { code: "0763", name: "建築金物工事業" },
  { code: "0771", name: "塗装工事業（道路標示・区画線工事業を除く）" },
  { code: "0772", name: "道路標示・区画線工事業" },
  { code: "0781", name: "床工事業" },
  { code: "0782", name: "内装工事業" },
  { code: "0791", name: "ガラス工事業" },
  { code: "0792", name: "金属製建具工事業" },
  { code: "0793", name: "木製建具工事業" },
  { code: "0794", name: "屋根工事業（金属製屋根工事業を除く）" },
  { code: "0795", name: "防水工事業" },
  { code: "0796", name: "解体・はつり工事業" },
  { code: "0799", name: "他に分類されない職別工事業" },
  { code: "0800", name: "主として管理事務を行う本社等" },
  { code: "0809", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "0811", name: "一般電気工事業" },
  { code: "0812", name: "電気配線工事業" },
  { code: "0821", name: "電気通信工事業（有線テレビジョン放送設備設置工事業を除く）" },
  { code: "0822", name: "有線テレビジョン放送設備設置工事業" },
  { code: "0823", name: "信号装置工事業" },
  { code: "0831", name: "一般管工事業" },
  { code: "0832", name: "冷暖房設備工事業" },
  { code: "0833", name: "給排水・衛生設備工事業" },
  { code: "0839", name: "その他の管工事業" },
  { code: "0841", name: "機械器具設置工事業（昇降設備工事業を除く）" },
  { code: "0842", name: "昇降設備工事業" },
  { code: "0891", name: "築炉工事業" },
  { code: "0892", name: "熱絶縁工事業" },
  { code: "0893", name: "道路標識設置工事業" },
  { code: "0894", name: "さく井工事業" },
  { code: "0900", name: "主として管理事務を行う本社等" },
  { code: "0909", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "0911", name: "部分肉・冷凍肉製造業" },
  { code: "0912", name: "肉加工品製造業" },
  { code: "0913", name: "処理牛乳・乳飲料製造業" },
  { code: "0914", name: "乳製品製造業（処理牛乳、乳飲料を除く）" },
  { code: "0919", name: "その他の畜産食料品製造業" },
  { code: "0921", name: "水産缶詰・瓶詰製造業" },
  { code: "0922", name: "海藻加工業" },
  { code: "0923", name: "水産練製品製造業" },
  { code: "0924", name: "塩干・塩蔵品製造業" },
  { code: "0925", name: "冷凍水産物製造業" },
  { code: "0926", name: "冷凍水産食品製造業" },
  { code: "0929", name: "その他の水産食料品製造業" },
  { code: "0931", name: "野菜缶詰・果実缶詰・農産保存食料品製造業（野菜漬物を除く）" },
  { code: "0932", name: "野菜漬物製造業（缶詰、瓶詰、つぼ詰を除く）" },
  { code: "0941", name: "味そ製造業" },
  { code: "0942", name: "しょう油・食用アミノ酸製造業" },
  { code: "0943", name: "ソース製造業" },
  { code: "0944", name: "食酢製造業" },
  { code: "0949", name: "その他の調味料製造業" },
  { code: "0951", name: "砂糖製造業（砂糖精製業を除く）" },
  { code: "0952", name: "砂糖精製業" },
  { code: "0953", name: "でんぷん糖類製造業" },
  { code: "0961", name: "精米・精麦業" },
  { code: "0962", name: "小麦粉製造業" },
  { code: "0969", name: "その他の精穀・製粉業" },
  { code: "0971", name: "パン製造業" },
  { code: "0972", name: "生菓子製造業" },
  { code: "0973", name: "ビスケット類・干菓子製造業" },
  { code: "0974", name: "米菓製造業" },
  { code: "0979", name: "その他のパン・菓子製造業" },
  { code: "0981", name: "動植物油脂製造業（食用油脂加工業を除く）" },
  { code: "0982", name: "食用油脂加工業" },
  { code: "0991", name: "でんぷん製造業" },
  { code: "0992", name: "めん類製造業" },
  { code: "0993", name: "豆腐・油揚製造業" },
  { code: "0994", name: "あん類製造業" },
  { code: "0995", name: "冷凍調理食品製造業" },
  { code: "0996", name: "そう（惣）菜製造業" },
  { code: "0997", name: "すし・弁当・調理パン製造業" },
  { code: "0998", name: "レトルト食品製造業" },
  { code: "0999", name: "他に分類されない食料品製造業" },
  { code: "1000", name: "主として管理事務を行う本社等" },
  { code: "1009", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "1011", name: "清涼飲料製造業" },
  { code: "1021", name: "果実酒製造業" },
  { code: "1022", name: "発泡性酒類製造業" },
  { code: "1023", name: "清酒製造業" },
  { code: "1024", name: "醸造酒類製造業（果実酒、清酒を除く）" },
  { code: "1025", name: "蒸留酒類製造業" },
  { code: "1026", name: "混成酒類製造業" },
  { code: "1031", name: "製茶業" },
  { code: "1032", name: "コーヒー製造業" },
  { code: "1041", name: "製氷業" },
  { code: "1051", name: "たばこ製造業（葉たばこ処理業を除く)" },
  { code: "1052", name: "葉たばこ処理業" },
  { code: "1061", name: "配合飼料製造業" },
  { code: "1062", name: "単体飼料製造業" },
  { code: "1063", name: "有機質肥料製造業" },
  { code: "1100", name: "主として管理事務を行う本社等" },
  { code: "1109", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "1111", name: "製糸業" },
  { code: "1112", name: "化学繊維製造業" },
  { code: "1113", name: "炭素繊維製造業" },
  { code: "1114", name: "綿紡績業" },
  { code: "1115", name: "化学繊維紡績業" },
  { code: "1116", name: "毛紡績業" },
  { code: "1117", name: "ねん糸製造業（かさ高加工糸を除く）" },
  { code: "1118", name: "かさ高加工糸製造業" },
  { code: "1119", name: "その他の紡績業" },
  { code: "1121", name: "綿・スフ織物業" },
  { code: "1122", name: "絹・人絹織物業" },
  { code: "1123", name: "毛織物業" },
  { code: "1124", name: "麻織物業" },
  { code: "1125", name: "細幅織物業" },
  { code: "1129", name: "その他の織物業" },
  { code: "1131", name: "丸編ニット生地製造業" },
  { code: "1132", name: "たて編ニット生地製造業" },
  { code: "1133", name: "横編ニット生地製造業" },
  { code: "1141", name: "綿・スフ・麻織物機械染色業" },
  { code: "1142", name: "絹・人絹織物機械染色業" },
  { code: "1143", name: "毛織物機械染色整理業" },
  { code: "1144", name: "織物整理業" },
  { code: "1145", name: "織物手加工染色整理業" },
  { code: "1146", name: "綿状繊維・糸染色整理業" },
  { code: "1147", name: "ニット・レース染色整理業" },
  { code: "1148", name: "繊維雑品染色整理業" },
  { code: "1151", name: "綱製造業" },
  { code: "1152", name: "漁網製造業" },
  { code: "1153", name: "網地製造業（漁網を除く）" },
  { code: "1154", name: "レース製造業" },
  { code: "1155", name: "組ひも製造業" },
  { code: "1156", name: "整毛業" },
  { code: "1157", name: "フェルト・不織布製造業" },
  { code: "1158", name: "上塗りした織物・防水した織物製造業" },
  { code: "1159", name: "その他の繊維粗製品製造業" },
  { code: "1161", name: "織物製成人男子・少年服製造業（不織布製及びレース製を含む）" },
  { code: "1162", name: "織物製成人女子・少女服製造業（不織布製及びレース製を含む）" },
  { code: "1163", name: "織物製乳幼児服製造業（不織布製及びレース製を含む）" },
  { code: "1164", name: "織物製シャツ製造業（不織布製及びレース製を含み、下着を除く）" },
  {
    code: "1165",
    name: "織物製事務用・作業用・衛生用・スポーツ用衣服・学校服製造業（不織布製及びレース製を含む）",
  },
  { code: "1166", name: "ニット製外衣製造業（アウターシャツ類、セーター類等を除く）" },
  { code: "1167", name: "ニット製アウターシャツ類製造業" },
  { code: "1168", name: "セーター類製造業" },
  { code: "1169", name: "その他の外衣・シャツ製造業" },
  { code: "1171", name: "織物製下着製造業" },
  { code: "1172", name: "ニット製下着製造業" },
  { code: "1173", name: "織物製・ニット製寝着類製造業" },
  { code: "1174", name: "補整着製造業" },
  { code: "1181", name: "和装製品製造業（足袋を含む）" },
  { code: "1182", name: "ネクタイ製造業" },
  { code: "1183", name: "スカーフ・マフラー・ハンカチーフ製造業" },
  { code: "1184", name: "靴下製造業" },
  { code: "1185", name: "手袋製造業" },
  { code: "1186", name: "帽子製造業（帽体を含む）" },
  { code: "1189", name: "他に分類されない衣服・繊維製身の回り品製造業" },
  { code: "1191", name: "寝具製造業" },
  { code: "1192", name: "毛布製造業" },
  { code: "1193", name: "じゅうたん・その他の繊維製床敷物製造業" },
  { code: "1194", name: "帆布製品製造業" },
  { code: "1195", name: "繊維製袋製造業" },
  { code: "1196", name: "刺しゅう業" },
  { code: "1197", name: "タオル製造業" },
  { code: "1198", name: "繊維製衛生材料製造業" },
  { code: "1199", name: "他に分類されない繊維製品製造業" },
  { code: "1200", name: "主として管理事務を行う本社等" },
  { code: "1209", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "1211", name: "一般製材業" },
  { code: "1212", name: "単板（ベニヤ）製造業" },
  { code: "1213", name: "木材チップ製造業" },
  { code: "1219", name: "その他の特殊製材業" },
  { code: "1221", name: "造作材製造業（建具を除く）" },
  { code: "1222", name: "合板製造業" },
  { code: "1223", name: "集成材製造業" },
  { code: "1224", name: "建築用木製組立材料製造業" },
  { code: "1225", name: "パーティクルボード製造業" },
  { code: "1226", name: "繊維板製造業" },
  { code: "1227", name: "銘木製造業" },
  { code: "1228", name: "床板製造業" },
  { code: "1231", name: "竹・とう・きりゅう等容器製造業" },
  { code: "1232", name: "木箱製造業" },
  { code: "1233", name: "たる・おけ製造業" },
  { code: "1291", name: "木材薬品処理業" },
  { code: "1292", name: "コルク加工基礎資材・コルク製品製造業" },
  { code: "1299", name: "他に分類されない木製品製造業(竹、とうを含む)" },
  { code: "1300", name: "主として管理事務を行う本社等" },
  { code: "1309", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "1311", name: "木製家具製造業（漆塗りを除く）" },
  { code: "1312", name: "金属製家具製造業" },
  { code: "1313", name: "マットレス・組スプリング製造業" },
  { code: "1321", name: "宗教用具製造業" },
  { code: "1331", name: "建具製造業" },
  { code: "1391", name: "事務所用・店舗用装備品製造業" },
  { code: "1392", name: "窓用・扉用日よけ、日本びょうぶ等製造業" },
  { code: "1393", name: "鏡縁・額縁製造業" },
  { code: "1399", name: "他に分類されない家具・装備品製造業" },
  { code: "1400", name: "主として管理事務を行う本社等" },
  { code: "1409", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "1411", name: "パルプ製造業" },
  { code: "1421", name: "洋紙製造業" },
  { code: "1422", name: "板紙製造業" },
  { code: "1423", name: "機械すき和紙製造業" },
  { code: "1424", name: "手すき和紙製造業" },
  { code: "1431", name: "塗工紙製造業（印刷用紙を除く）" },
  { code: "1432", name: "段ボール製造業" },
  { code: "1433", name: "壁紙・ふすま紙製造業" },
  { code: "1441", name: "事務用・学用紙製品製造業" },
  { code: "1442", name: "日用紙製品製造業" },
  { code: "1449", name: "その他の紙製品製造業" },
  { code: "1451", name: "重包装紙袋製造業" },
  { code: "1452", name: "角底紙袋製造業" },
  { code: "1453", name: "段ボール箱製造業" },
  { code: "1454", name: "紙器製造業" },
  { code: "1499", name: "その他のパルプ・紙・紙加工品製造業" },
  { code: "1500", name: "主として管理事務を行う本社等" },
  { code: "1509", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "1511", name: "オフセット印刷業（紙に対するもの）" },
  { code: "1512", name: "オフセット印刷以外の印刷業（紙に対するもの）" },
  { code: "1513", name: "紙以外の印刷業" },
  { code: "1521", name: "製版業" },
  { code: "1531", name: "製本業" },
  { code: "1532", name: "印刷物加工業" },
  { code: "1591", name: "印刷関連サービス業" },
  { code: "1600", name: "主として管理事務を行う本社等" },
  { code: "1609", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "1611", name: "窒素質・りん酸質肥料製造業" },
  { code: "1612", name: "複合肥料製造業" },
  { code: "1619", name: "その他の化学肥料製造業" },
  { code: "1621", name: "ソーダ工業" },
  { code: "1622", name: "無機顔料製造業" },
  { code: "1623", name: "圧縮ガス・液化ガス製造業" },
  { code: "1624", name: "塩製造業" },
  { code: "1629", name: "その他の無機化学工業製品製造業" },
  { code: "1631", name: "石油化学系基礎製品製造業（一貫して生産される誘導品を含む）" },
  { code: "1632", name: "脂肪族系中間物製造業（脂肪族系溶剤を含む）" },
  { code: "1633", name: "発酵工業" },
  { code: "1634", name: "環式中間物・合成染料・有機顔料製造業" },
  { code: "1635", name: "プラスチック製造業" },
  { code: "1636", name: "合成ゴム製造業" },
  { code: "1639", name: "その他の有機化学工業製品製造業" },
  { code: "1641", name: "脂肪酸・硬化油・グリセリン製造業" },
  { code: "1642", name: "石けん・合成洗剤製造業" },
  { code: "1643", name: "界面活性剤製造業（石けん、合成洗剤を除く）" },
  { code: "1644", name: "塗料製造業" },
  { code: "1645", name: "印刷インキ製造業" },
  { code: "1646", name: "洗浄剤・磨用剤製造業" },
  { code: "1647", name: "ろうそく製造業" },
  { code: "1651", name: "医薬品原薬製造業" },
  { code: "1652", name: "医薬品製剤製造業" },
  { code: "1653", name: "生物学的製剤製造業" },
  { code: "1654", name: "生薬・漢方製剤製造業" },
  { code: "1655", name: "動物用医薬品製造業" },
  { code: "1661", name: "仕上用・皮膚用化粧品製造業（香水、オーデコロンを含む）" },
  { code: "1662", name: "頭髪用化粧品製造業" },
  { code: "1669", name: "その他の化粧品・歯磨・化粧用調整品製造業" },
  { code: "1691", name: "火薬類製造業" },
  { code: "1692", name: "農薬製造業" },
  { code: "1693", name: "香料製造業" },
  { code: "1694", name: "ゼラチン・接着剤製造業" },
  { code: "1695", name: "写真感光材料製造業" },
  { code: "1696", name: "天然樹脂製品・木材化学製品製造業" },
  { code: "1697", name: "試薬製造業" },
  { code: "1699", name: "他に分類されない化学工業製品製造業" },
  { code: "1700", name: "主として管理事務を行う本社等" },
  { code: "1709", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "1711", name: "石油精製業" },
  { code: "1721", name: "潤滑油・グリース製造業（石油精製によらないもの）" },
  { code: "1731", name: "コークス製造業" },
  { code: "1741", name: "舗装材料製造業" },
  { code: "1799", name: "その他の石油製品・石炭製品製造業" },
  { code: "1800", name: "主として管理事務を行う本社等" },
  { code: "1809", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "1811", name: "プラスチック板・棒製造業" },
  { code: "1812", name: "プラスチック管製造業" },
  { code: "1813", name: "プラスチック継手製造業" },
  { code: "1814", name: "プラスチック異形押出製品製造業" },
  { code: "1815", name: "プラスチック板・棒・管・継手・異形押出製品加工業" },
  { code: "1821", name: "プラスチックフィルム製造業" },
  { code: "1822", name: "プラスチックシート製造業" },
  { code: "1823", name: "プラスチック床材製造業" },
  { code: "1824", name: "合成皮革製造業" },
  { code: "1825", name: "プラスチックフィルム・シート・床材・合成皮革加工業" },
  { code: "1831", name: "電気機械器具用プラスチック製品製造業（加工業を除く）" },
  { code: "1832", name: "輸送機械器具用プラスチック製品製造業（加工業を除く）" },
  { code: "1833", name: "その他の工業用プラスチック製品製造業（加工業を除く）" },
  { code: "1834", name: "工業用プラスチック製品加工業" },
  { code: "1841", name: "軟質プラスチック発泡製品製造業（半硬質性を含む）" },
  { code: "1842", name: "硬質プラスチック発泡製品製造業" },
  { code: "1843", name: "強化プラスチック製板・棒・管・継手製造業" },
  { code: "1844", name: "強化プラスチック製容器・浴槽等製造業" },
  { code: "1845", name: "発泡・強化プラスチック製品加工業" },
  { code: "1851", name: "プラスチック成形材料製造業" },
  { code: "1852", name: "廃プラスチック製品製造業" },
  { code: "1891", name: "プラスチック製日用雑貨・食卓用品製造業" },
  { code: "1892", name: "プラスチック製容器製造業" },
  { code: "1897", name: "他に分類されないプラスチック製品製造業" },
  { code: "1898", name: "他に分類されないプラスチック製品加工業" },
  { code: "1900", name: "主として管理事務を行う本社等" },
  { code: "1909", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "1911", name: "自動車タイヤ・チューブ製造業" },
  { code: "1919", name: "その他のタイヤ・チューブ製造業" },
  { code: "1921", name: "ゴム製履物・同附属品製造業" },
  { code: "1922", name: "プラスチック製履物・同附属品製造業" },
  { code: "1931", name: "ゴムベルト製造業" },
  { code: "1932", name: "ゴムホース製造業" },
  { code: "1933", name: "工業用ゴム製品製造業" },
  { code: "1991", name: "ゴム引布・同製品製造業" },
  { code: "1992", name: "医療・衛生用ゴム製品製造業" },
  { code: "1993", name: "ゴム練生地製造業" },
  { code: "1994", name: "更生タイヤ製造業" },
  { code: "1995", name: "再生ゴム製造業" },
  { code: "1999", name: "他に分類されないゴム製品製造業" },
  { code: "2000", name: "主として管理事務を行う本社等" },
  { code: "2009", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "2011", name: "なめし革製造業" },
  { code: "2021", name: "工業用革製品製造業（手袋を除く）" },
  { code: "2031", name: "革製履物用材料・同附属品製造業" },
  { code: "2041", name: "革製履物製造業" },
  { code: "2051", name: "革製手袋製造業" },
  { code: "2061", name: "かばん製造業" },
  { code: "2071", name: "袋物製造業（ハンドバッグを除く）" },
  { code: "2072", name: "ハンドバッグ製造業" },
  { code: "2081", name: "毛皮製造業" },
  { code: "2099", name: "その他のなめし革製品製造業" },
  { code: "2100", name: "主として管理事務を行う本社等" },
  { code: "2109", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "2111", name: "板ガラス製造業" },
  { code: "2112", name: "板ガラス加工業" },
  { code: "2113", name: "ガラス製加工素材製造業" },
  { code: "2114", name: "ガラス容器製造業" },
  { code: "2115", name: "理化学用・医療用ガラス器具製造業" },
  { code: "2116", name: "卓上用・ちゅう房用ガラス器具製造業" },
  { code: "2117", name: "ガラス繊維・同製品製造業" },
  { code: "2119", name: "その他のガラス・同製品製造業" },
  { code: "2121", name: "セメント製造業" },
  { code: "2122", name: "生コンクリート製造業" },
  { code: "2123", name: "コンクリート製品製造業" },
  { code: "2129", name: "その他のセメント製品製造業" },
  { code: "2131", name: "粘土がわら製造業" },
  { code: "2132", name: "普通れんが製造業" },
  { code: "2139", name: "その他の建設用粘土製品製造業" },
  { code: "2141", name: "衛生陶器製造業" },
  { code: "2142", name: "食卓用・ちゅう房用陶磁器製造業" },
  { code: "2143", name: "陶磁器製置物製造業" },
  { code: "2144", name: "電気用陶磁器製造業" },
  { code: "2145", name: "理化学用・工業用陶磁器製造業" },
  { code: "2146", name: "陶磁器製タイル製造業" },
  { code: "2147", name: "陶磁器絵付業" },
  { code: "2148", name: "陶磁器用はい（坏）土製造業" },
  { code: "2149", name: "その他の陶磁器・同関連製品製造業" },
  { code: "2151", name: "耐火れんが製造業" },
  { code: "2152", name: "不定形耐火物製造業" },
  { code: "2159", name: "その他の耐火物製造業" },
  { code: "2161", name: "炭素質電極製造業" },
  { code: "2169", name: "その他の炭素・黒鉛製品製造業" },
  { code: "2171", name: "研磨材製造業" },
  { code: "2172", name: "研削と石製造業" },
  { code: "2173", name: "研磨布紙製造業" },
  { code: "2179", name: "その他の研磨材・同製品製造業" },
  { code: "2181", name: "砕石製造業" },
  { code: "2182", name: "再生骨材製造業" },
  { code: "2183", name: "人工骨材製造業" },
  { code: "2184", name: "石工品製造業" },
  { code: "2185", name: "けいそう土・同製品製造業" },
  { code: "2186", name: "鉱物・土石粉砕等処理業" },
  { code: "2191", name: "ロックウール・同製品製造業" },
  { code: "2192", name: "石こう（膏）製品製造業" },
  { code: "2193", name: "石灰製造業" },
  { code: "2194", name: "鋳型製造業（中子を含む）" },
  { code: "2199", name: "他に分類されない窯業・土石製品製造業" },
  { code: "2200", name: "主として管理事務を行う本社等" },
  { code: "2209", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "2211", name: "高炉による製鉄業" },
  { code: "2212", name: "高炉によらない製鉄業" },
  { code: "2213", name: "フェロアロイ製造業" },
  { code: "2221", name: "製鋼・製鋼圧延業" },
  { code: "2231", name: "熱間圧延業（鋼管、伸鉄を除く）" },
  { code: "2232", name: "冷間圧延業（鋼管、伸鉄を除く）" },
  { code: "2233", name: "冷間ロール成型形鋼製造業" },
  { code: "2234", name: "鋼管製造業" },
  { code: "2235", name: "伸鉄業" },
  { code: "2236", name: "磨棒鋼製造業" },
  { code: "2237", name: "引抜鋼管製造業" },
  { code: "2238", name: "伸線業" },
  { code: "2239", name: "その他の製鋼を行わない鋼材製造業（表面処理鋼材を除く)" },
  { code: "2241", name: "亜鉛鉄板製造業" },
  { code: "2249", name: "その他の表面処理鋼材製造業" },
  { code: "2251", name: "銑鉄鋳物製造業（鋳鉄管、可鍛鋳鉄を除く）" },
  { code: "2252", name: "可鍛鋳鉄製造業" },
  { code: "2253", name: "鋳鋼製造業" },
  { code: "2254", name: "鍛工品製造業" },
  { code: "2255", name: "鍛鋼製造業" },
  { code: "2291", name: "鉄鋼シャースリット業" },
  { code: "2292", name: "鉄スクラップ加工処理業" },
  { code: "2293", name: "鋳鉄管製造業" },
  { code: "2299", name: "他に分類されない鉄鋼業" },
  { code: "2300", name: "主として管理事務を行う本社等" },
  { code: "2309", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "2311", name: "銅第１次製錬・精製業" },
  { code: "2312", name: "亜鉛第１次製錬・精製業" },
  { code: "2319", name: "その他の非鉄金属第１次製錬・精製業" },
  { code: "2321", name: "鉛第２次製錬・精製業（鉛合金製造業を含む)" },
  { code: "2322", name: "アルミニウム第２次製錬・精製業（アルミニウム合金製造業を含む）" },
  { code: "2329", name: "その他の非鉄金属第２次製錬・精製業（非鉄金属合金製造業を含む）" },
  { code: "2331", name: "伸銅品製造業" },
  { code: "2332", name: "アルミニウム・同合金圧延業（抽伸、押出しを含む）" },
  { code: "2339", name: "その他の非鉄金属・同合金圧延業（抽伸、押出しを含む）" },
  { code: "2341", name: "電線・ケーブル製造業（光ファイバケーブルを除く）" },
  { code: "2342", name: "光ファイバケーブル製造業（通信複合ケーブルを含む）" },
  { code: "2351", name: "銅・同合金鋳物製造業（ダイカストを除く）" },
  { code: "2352", name: "非鉄金属鋳物製造業（銅・同合金鋳物及びダイカストを除く）" },
  { code: "2353", name: "アルミニウム・同合金ダイカスト製造業" },
  { code: "2354", name: "非鉄金属ダイカスト製造業（アルミニウム・同合金ダイカストを除く）" },
  { code: "2355", name: "非鉄金属鍛造品製造業" },
  { code: "2391", name: "核燃料製造業" },
  { code: "2399", name: "他に分類されない非鉄金属製造業" },
  { code: "2400", name: "主として管理事務を行う本社等" },
  { code: "2409", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "2411", name: "ブリキ缶・その他のめっき板等製品製造業" },
  { code: "2421", name: "洋食器製造業" },
  { code: "2422", name: "機械刃物製造業" },
  { code: "2423", name: "利器工匠具・手道具製造業（やすり、のこぎり、食卓用刃物を除く）" },
  { code: "2424", name: "作業工具製造業" },
  { code: "2425", name: "手引のこぎり・のこ刃製造業" },
  { code: "2426", name: "農業用器具製造業（農業用機械を除く）" },
  { code: "2429", name: "その他の金物類製造業" },
  { code: "2431", name: "配管工事用附属品製造業（バルブ、コックを除く）" },
  { code: "2432", name: "ガス機器・石油機器製造業" },
  { code: "2433", name: "温風・温水暖房装置製造業" },
  { code: "2439", name: "その他の暖房・調理装置製造業（電気機械器具、ガス機器、石油機器を除く）" },
  { code: "2441", name: "鉄骨製造業" },
  { code: "2442", name: "建設用金属製品製造業（鉄骨を除く）" },
  { code: "2443", name: "金属製サッシ・ドア製造業" },
  { code: "2444", name: "鉄骨系プレハブ住宅製造業" },
  { code: "2445", name: "建築用金属製品製造業（サッシ、ドア、建築用金物を除く）" },
  { code: "2446", name: "製缶板金業" },
  { code: "2451", name: "アルミニウム・同合金プレス製品製造業" },
  { code: "2452", name: "金属プレス製品製造業（アルミニウム・同合金を除く）" },
  { code: "2453", name: "粉末や金製品製造業" },
  { code: "2461", name: "金属製品塗装業" },
  { code: "2462", name: "溶融めっき業（表面処理鋼材製造業を除く）" },
  { code: "2463", name: "金属彫刻業" },
  { code: "2464", name: "電気めっき業（表面処理鋼材製造業を除く）" },
  { code: "2465", name: "金属熱処理業" },
  { code: "2469", name: "その他の金属表面処理業" },
  { code: "2471", name: "くぎ製造業" },
  { code: "2479", name: "その他の金属線製品製造業" },
  { code: "2481", name: "ボルト・ナット・リベット・小ねじ・木ねじ等製造業" },
  { code: "2491", name: "金庫製造業" },
  { code: "2492", name: "金属製スプリング製造業" },
  { code: "2499", name: "他に分類されない金属製品製造業" },
  { code: "2500", name: "主として管理事務を行う本社等" },
  { code: "2509", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "2511", name: "ボイラ製造業" },
  { code: "2512", name: "蒸気機関・タービン・水力タービン製造業（舶用を除く）" },
  { code: "2513", name: "はん用内燃機関製造業" },
  { code: "2519", name: "その他の原動機製造業" },
  { code: "2521", name: "ポンプ・同装置製造業" },
  { code: "2522", name: "空気圧縮機・ガス圧縮機・送風機製造業" },
  { code: "2523", name: "油圧･空圧機器製造業" },
  { code: "2531", name: "動力伝導装置製造業（玉軸受、ころ軸受を除く）" },
  { code: "2532", name: "エレベータ・エスカレータ製造業" },
  { code: "2533", name: "物流運搬設備製造業" },
  { code: "2534", name: "工業窯炉製造業（燃焼炉）" },
  { code: "2535", name: "冷凍機・温湿調整装置製造業" },
  { code: "2591", name: "消火器具・消火装置製造業" },
  { code: "2592", name: "弁・同附属品製造業" },
  { code: "2593", name: "パイプ加工・パイプ附属品加工業" },
  { code: "2594", name: "玉軸受・ころ軸受製造業" },
  { code: "2595", name: "ピストンリング製造業" },
  { code: "2596", name: "他に分類されないはん用機械・装置製造業" },
  { code: "2599", name: "各種機械・同部分品製造修理業（注文製造・修理）" },
  { code: "2600", name: "主として管理事務を行う本社等" },
  { code: "2609", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "2611", name: "農業用機械製造業（農業用器具を除く）" },
  { code: "2621", name: "建設機械・鉱山機械製造業" },
  { code: "2631", name: "化学繊維機械・紡績機械製造業" },
  { code: "2632", name: "製織機械・編組機械製造業" },
  { code: "2633", name: "染色整理仕上機械製造業" },
  { code: "2634", name: "繊維機械部分品・取付具・附属品製造業" },
  { code: "2635", name: "縫製機械製造業" },
  { code: "2641", name: "食品機械・同装置製造業" },
  { code: "2642", name: "木材加工機械製造業" },
  { code: "2643", name: "パルプ装置・製紙機械製造業" },
  { code: "2644", name: "印刷・製本・紙工機械製造業" },
  { code: "2645", name: "包装・荷造機械製造業" },
  { code: "2651", name: "鋳造装置製造業" },
  { code: "2652", name: "化学機械・同装置製造業" },
  { code: "2653", name: "プラスチック加工機械・同附属装置製造業" },
  { code: "2661", name: "金属工作機械製造業" },
  { code: "2662", name: "金属加工機械製造業（金属工作機械を除く）" },
  {
    code: "2663",
    name: "金属工作機械用・金属加工機械用部分品・附属品製造業（機械工具、金型を除く）",
  },
  { code: "2664", name: "機械工具製造業（粉末や金業を除く）" },
  { code: "2671", name: "半導体製造装置製造業" },
  { code: "2672", name: "フラットパネルディスプレイ製造装置製造業" },
  { code: "2691", name: "金属用金型・同部分品・附属品製造業" },
  { code: "2692", name: "非金属用金型・同部分品・附属品製造業" },
  { code: "2693", name: "真空装置・真空機器製造業" },
  { code: "2694", name: "ロボット製造業" },
  { code: "2699", name: "他に分類されない生産用機械・同部分品製造業" },
  { code: "2700", name: "主として管理事務を行う本社等" },
  { code: "2709", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "2711", name: "複写機製造業" },
  { code: "2719", name: "その他の事務用機械器具製造業" },
  { code: "2721", name: "サービス用機械器具製造業" },
  { code: "2722", name: "娯楽用機械製造業" },
  { code: "2723", name: "自動販売機製造業" },
  { code: "2729", name: "その他のサービス用・娯楽用機械器具製造業" },
  { code: "2731", name: "体積計製造業" },
  { code: "2732", name: "はかり製造業" },
  { code: "2733", name: "圧力計・流量計・液面計等製造業" },
  { code: "2734", name: "精密測定器製造業" },
  { code: "2735", name: "分析機器製造業" },
  { code: "2736", name: "試験機製造業" },
  { code: "2737", name: "測量機械器具製造業" },
  { code: "2738", name: "理化学機械器具製造業" },
  {
    code: "2739",
    name: "その他の計量器・測定器・分析機器・試験機・測量機械器具・理化学機械器具製造業",
  },
  { code: "2741", name: "医療用機械器具製造業" },
  { code: "2742", name: "歯科用機械器具製造業" },
  { code: "2743", name: "医療用品製造業（動物用医療機械器具を含む）" },
  { code: "2744", name: "歯科材料製造業" },
  { code: "2751", name: "顕微鏡・望遠鏡等製造業" },
  { code: "2752", name: "写真機・映画用機械・同附属品製造業" },
  { code: "2753", name: "光学機械用レンズ・プリズム製造業" },
  { code: "2761", name: "武器製造業" },
  { code: "2800", name: "主として管理事務を行う本社等" },
  { code: "2809", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "2811", name: "電子管製造業" },
  { code: "2812", name: "光電変換素子製造業" },
  { code: "2813", name: "半導体素子製造業（光電変換素子を除く）" },
  { code: "2814", name: "集積回路製造業" },
  { code: "2815", name: "液晶パネル・フラットパネル製造業" },
  { code: "2821", name: "抵抗器・コンデンサ・変成器・複合部品製造業" },
  { code: "2822", name: "音響部品・磁気ヘッド・小形モーター製造業" },
  { code: "2823", name: "コネクタ・スイッチ・リレー製造業" },
  { code: "2831", name: "半導体メモリメディア製造業" },
  { code: "2832", name: "光ディスク・磁気ディスク・磁気テープ製造業" },
  { code: "2841", name: "電子回路基板製造業" },
  { code: "2842", name: "電子回路実装基板製造業" },
  { code: "2851", name: "電源ユニット・高周波ユニット・コントロールユニット製造業" },
  { code: "2859", name: "その他のユニット部品製造業" },
  { code: "2899", name: "その他の電子部品・デバイス・電子回路製造業" },
  { code: "2900", name: "主として管理事務を行う本社等" },
  { code: "2909", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "2911", name: "発電機・電動機・その他の回転電気機械製造業" },
  { code: "2912", name: "変圧器類製造業（電子機器用を除く)" },
  { code: "2913", name: "電力開閉装置製造業" },
  { code: "2914", name: "配電盤・電力制御装置製造業" },
  { code: "2915", name: "配線器具・配線附属品製造業" },
  { code: "2921", name: "電気溶接機製造業" },
  { code: "2922", name: "内燃機関電装品製造業" },
  { code: "2923", name: "電気炉・電熱装置製造業" },
  { code: "2929", name: "その他の産業用電気機械器具製造業（車両用、船舶用を含む）" },
  { code: "2931", name: "ちゅう房機器製造業" },
  { code: "2932", name: "空調・住宅関連機器製造業" },
  { code: "2933", name: "衣料衛生関連機器製造業" },
  { code: "2939", name: "その他の民生用電気機械器具製造業" },
  { code: "2941", name: "電球製造業" },
  { code: "2942", name: "電気照明器具製造業" },
  { code: "2951", name: "蓄電池製造業" },
  { code: "2952", name: "一次電池（乾電池、湿電池）製造業" },
  { code: "2961", name: "Ｘ線装置製造業" },
  { code: "2962", name: "医療用電子応用装置製造業" },
  { code: "2969", name: "その他の電子応用装置製造業" },
  { code: "2971", name: "電気計測器製造業（別掲を除く）" },
  { code: "2972", name: "工業計器製造業" },
  { code: "2973", name: "医療用計測器製造業" },
  { code: "2999", name: "その他の電気機械器具製造業" },
  { code: "3000", name: "主として管理事務を行う本社等" },
  { code: "3009", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "3011", name: "有線通信機械器具製造業" },
  { code: "3012", name: "スマートフォン・携帯電話機・ＰＨＳ電話機製造業" },
  { code: "3013", name: "無線通信機械器具製造業" },
  { code: "3014", name: "ラジオ受信機・テレビジョン受信機製造業" },
  { code: "3015", name: "交通信号保安装置製造業" },
  { code: "3019", name: "その他の通信機械器具・同関連機械器具製造業" },
  { code: "3021", name: "ビデオ機器製造業" },
  { code: "3022", name: "デジタルカメラ製造業" },
  { code: "3023", name: "電気音響機械器具製造業" },
  { code: "3031", name: "電子計算機製造業（パーソナルコンピュータを除く）" },
  { code: "3032", name: "パーソナルコンピュータ製造業" },
  { code: "3033", name: "外部記憶装置製造業" },
  { code: "3034", name: "印刷装置製造業" },
  { code: "3035", name: "表示装置製造業" },
  { code: "3039", name: "その他の附属装置製造業" },
  { code: "3100", name: "主として管理事務を行う本社等" },
  { code: "3109", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "3111", name: "自動車製造業（二輪自動車を含む）" },
  { code: "3112", name: "自動車車体・附随車製造業" },
  { code: "3113", name: "自動車部分品・附属品製造業" },
  { code: "3121", name: "鉄道車両製造業" },
  { code: "3122", name: "鉄道車両用部分品製造業" },
  { code: "3131", name: "船舶製造・修理業" },
  { code: "3132", name: "船体ブロック製造業" },
  { code: "3133", name: "舟艇製造・修理業" },
  { code: "3134", name: "舶用機関製造業" },
  { code: "3141", name: "航空機製造業" },
  { code: "3142", name: "航空機用原動機製造業" },
  { code: "3149", name: "その他の航空機部分品・補助装置製造業" },
  { code: "3151", name: "フォークリフトトラック・同部分品・附属品製造業" },
  { code: "3159", name: "その他の産業用運搬車両・同部分品・附属品製造業" },
  { code: "3191", name: "自転車・同部分品製造業" },
  { code: "3199", name: "他に分類されない輸送用機械器具製造業" },
  { code: "3200", name: "主として管理事務を行う本社等" },
  { code: "3209", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "3211", name: "貴金属・宝石製装身具（ジュエリー）製品製造業" },
  { code: "3212", name: "貴金属・宝石製装身具（ジュエリー）附属品・同材料加工業" },
  { code: "3219", name: "その他の貴金属製品製造業" },
  { code: "3221", name: "装身具・装飾品製造業（貴金属・宝石製を除く）" },
  { code: "3222", name: "造花・装飾用羽毛製造業" },
  { code: "3223", name: "ボタン製造業" },
  { code: "3224", name: "針・ピン・ホック・スナップ・同関連品製造業" },
  { code: "3229", name: "その他の装身具・装飾品製造業" },
  { code: "3231", name: "時計・同部分品製造業" },
  { code: "3241", name: "ピアノ製造業" },
  { code: "3249", name: "その他の楽器・楽器部品・同材料製造業" },
  { code: "3251", name: "娯楽用具・がん具製造業（人形を除く）" },
  { code: "3252", name: "人形製造業" },
  { code: "3253", name: "運動用具製造業" },
  { code: "3261", name: "万年筆・ペン類・鉛筆製造業" },
  { code: "3262", name: "毛筆・絵画用品製造業（鉛筆を除く）" },
  { code: "3269", name: "その他の事務用品製造業" },
  { code: "3271", name: "漆器製造業" },
  { code: "3281", name: "麦わら・パナマ類帽子・わら工品製造業" },
  { code: "3282", name: "畳製造業" },
  { code: "3283", name: "うちわ・扇子・ちょうちん製造業" },
  { code: "3284", name: "ほうき・ブラシ製造業" },
  { code: "3285", name: "喫煙用具製造業（貴金属・宝石製を除く）" },
  { code: "3289", name: "その他の生活雑貨製品製造業" },
  { code: "3291", name: "煙火製造業" },
  { code: "3292", name: "看板・標識機製造業" },
  { code: "3293", name: "パレット製造業" },
  { code: "3294", name: "モデル・模型製造業" },
  { code: "3295", name: "工業用模型製造業" },
  { code: "3296", name: "情報記録物製造業（新聞、書籍等の印刷物を除く）" },
  { code: "3297", name: "眼鏡製造業（枠を含む）" },
  { code: "3299", name: "他に分類されないその他の製造業" },
  { code: "3300", name: "主として管理事務を行う本社等" },
  { code: "3309", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "3311", name: "発電業" },
  { code: "3312", name: "送配電業" },
  { code: "3313", name: "電気小売業" },
  { code: "3314", name: "電気卸供給業" },
  { code: "3400", name: "主として管理事務を行う本社等" },
  { code: "3409", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "3411", name: "ガス製造業" },
  { code: "3412", name: "ガス導管業" },
  { code: "3413", name: "ガス小売業" },
  { code: "3500", name: "主として管理事務を行う本社等" },
  { code: "3509", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "3511", name: "熱供給業" },
  { code: "3600", name: "主として管理事務を行う本社等" },
  { code: "3609", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "3611", name: "上水道業" },
  { code: "3621", name: "工業用水道業" },
  { code: "3631", name: "下水道処理施設維持管理業" },
  { code: "3632", name: "下水道管路施設維持管理業" },
  { code: "3700", name: "主として管理事務を行う本社等" },
  { code: "3709", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "3711", name: "地域電気通信業（有線放送電話業を除く）" },
  { code: "3712", name: "長距離電気通信業" },
  { code: "3713", name: "有線放送電話業" },
  { code: "3719", name: "その他の固定電気通信業" },
  { code: "3721", name: "移動電気通信業" },
  { code: "3731", name: "電気通信に附帯するサービス業" },
  { code: "3800", name: "主として管理事務を行う本社等" },
  { code: "3809", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "3811", name: "公共放送業（有線放送業を除く）" },
  { code: "3821", name: "テレビジョン放送業（衛星放送業を除く）" },
  { code: "3822", name: "ラジオ放送業（衛星放送業を除く）" },
  { code: "3823", name: "衛星放送業" },
  { code: "3829", name: "その他の民間放送業" },
  { code: "3831", name: "有線テレビジョン放送業" },
  { code: "3832", name: "有線ラジオ放送業" },
  { code: "3900", name: "主として管理事務を行う本社等" },
  { code: "3909", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "3911", name: "受託開発ソフトウェア業" },
  { code: "3912", name: "組込みソフトウェア業" },
  { code: "3913", name: "パッケージソフトウェア業" },
  { code: "3914", name: "ゲームソフトウェア業" },
  { code: "3921", name: "情報処理サービス業" },
  { code: "3922", name: "情報提供サービス業" },
  { code: "3923", name: "市場調査・世論調査・社会調査業" },
  { code: "3929", name: "その他の情報処理・提供サービス業" },
  { code: "4000", name: "主として管理事務を行う本社等" },
  { code: "4009", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "4011", name: "ポータルサイト・サーバ運営業" },
  { code: "4012", name: "アプリケーション・サービス・コンテンツ・プロバイダ" },
  { code: "4013", name: "インターネット利用サポート業" },
  { code: "4100", name: "主として管理事務を行う本社等" },
  { code: "4109", name: "その他の管理、補助的経済活動を行う事業所" },
  {
    code: "4111",
    name: "映画・ビデオ制作業（テレビジョン番組制作業、アニメーション制作業を除く）",
  },
  { code: "4112", name: "テレビジョン番組制作業（アニメーション制作業を除く）" },
  { code: "4113", name: "アニメーション制作業" },
  { code: "4114", name: "映画・ビデオ・テレビジョン番組配給業" },
  { code: "4121", name: "レコード制作業" },
  { code: "4122", name: "ラジオ番組制作業" },
  { code: "4131", name: "新聞業" },
  { code: "4141", name: "出版業" },
  { code: "4151", name: "広告制作業" },
  { code: "4161", name: "ニュース供給業" },
  { code: "4169", name: "その他の映像・音声・文字情報制作に附帯するサービス業" },
  { code: "4200", name: "主として管理事務を行う本社等" },
  { code: "4209", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "4211", name: "普通鉄道業" },
  { code: "4212", name: "軌道業" },
  { code: "4213", name: "地下鉄道業" },
  { code: "4214", name: "モノレール鉄道業（地下鉄道業を除く）" },
  { code: "4215", name: "案内軌条式鉄道業（地下鉄道業を除く）" },
  { code: "4216", name: "鋼索鉄道業" },
  { code: "4217", name: "索道業" },
  { code: "4219", name: "その他の鉄道業" },
  { code: "4300", name: "主として管理事務を行う本社等" },
  { code: "4309", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "4311", name: "一般乗合旅客自動車運送業" },
  { code: "4321", name: "一般乗用旅客自動車運送業" },
  { code: "4331", name: "一般貸切旅客自動車運送業" },
  { code: "4391", name: "特定旅客自動車運送業" },
  { code: "4399", name: "他に分類されない道路旅客運送業" },
  { code: "4400", name: "主として管理事務を行う本社等" },
  { code: "4409", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "4411", name: "一般貨物自動車運送業（特別積合せ貨物運送業を除く）" },
  { code: "4412", name: "特別積合せ貨物運送業" },
  { code: "4421", name: "特定貨物自動車運送業" },
  { code: "4431", name: "貨物軽自動車運送業" },
  { code: "4441", name: "集配利用運送業" },
  { code: "4499", name: "その他の道路貨物運送業" },
  { code: "4500", name: "主として管理事務を行う本社等" },
  { code: "4509", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "4511", name: "外航旅客海運業" },
  { code: "4512", name: "外航貨物海運業" },
  { code: "4521", name: "沿海旅客海運業" },
  { code: "4522", name: "沿海貨物海運業" },
  { code: "4531", name: "港湾旅客海運業" },
  { code: "4532", name: "河川水運業" },
  { code: "4533", name: "湖沼水運業" },
  { code: "4541", name: "船舶貸渡業（内航船舶貸渡業を除く）" },
  { code: "4542", name: "内航船舶貸渡業" },
  { code: "4600", name: "主として管理事務を行う本社等" },
  { code: "4609", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "4611", name: "航空運送業" },
  { code: "4621", name: "航空機使用業（航空運送業を除く）" },
  { code: "4700", name: "主として管理事務を行う本社等" },
  { code: "4709", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "4711", name: "倉庫業（冷蔵倉庫業を除く）" },
  { code: "4721", name: "冷蔵倉庫業" },
  { code: "4800", name: "主として管理事務を行う本社等" },
  { code: "4809", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "4811", name: "港湾運送業" },
  { code: "4821", name: "利用運送業（集配利用運送業を除く）" },
  { code: "4822", name: "運送取次業" },
  { code: "4831", name: "運送代理店" },
  { code: "4841", name: "こん包業（組立こん包業を除く）" },
  { code: "4842", name: "組立こん包業" },
  { code: "4851", name: "鉄道施設提供業" },
  { code: "4852", name: "道路運送固定施設業" },
  { code: "4853", name: "自動車ターミナル業" },
  { code: "4854", name: "貨物荷扱固定施設業" },
  { code: "4855", name: "桟橋泊きょ業" },
  { code: "4856", name: "飛行場業" },
  { code: "4891", name: "海運仲立業" },
  { code: "4892", name: "レッカー・ロードサービス業" },
  { code: "4899", name: "他に分類されない運輸に附帯するサービス業" },
  { code: "4901", name: "管理、補助的経済活動を行う事業所" },
  { code: "4911", name: "郵便業（信書便事業を含む）" },
  { code: "5000", name: "主として管理事務を行う本社等" },
  { code: "5008", name: "自家用倉庫" },
  { code: "5009", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "5011", name: "各種商品卸売業（従業者が常時100人以上のもの）" },
  { code: "5019", name: "その他の各種商品卸売業" },
  { code: "5100", name: "主として管理事務を行う本社等" },
  { code: "5108", name: "自家用倉庫" },
  { code: "5109", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "5111", name: "繊維原料卸売業" },
  { code: "5112", name: "糸卸売業" },
  { code: "5113", name: "織物卸売業（室内装飾繊維品を除く）" },
  { code: "5121", name: "男子服卸売業" },
  { code: "5122", name: "婦人・子供服卸売業" },
  { code: "5123", name: "下着類卸売業" },
  { code: "5129", name: "その他の衣服卸売業" },
  { code: "5131", name: "寝具類卸売業" },
  { code: "5132", name: "靴・履物卸売業" },
  { code: "5133", name: "かばん・袋物卸売業" },
  { code: "5139", name: "その他の身の回り品卸売業" },
  { code: "5200", name: "主として管理事務を行う本社等" },
  { code: "5208", name: "自家用倉庫" },
  { code: "5209", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "5211", name: "米麦卸売業" },
  { code: "5212", name: "雑穀・豆類卸売業" },
  { code: "5213", name: "野菜卸売業" },
  { code: "5214", name: "果実卸売業" },
  { code: "5215", name: "食肉卸売業" },
  { code: "5216", name: "生鮮魚介卸売業" },
  { code: "5219", name: "その他の農畜産物・水産物卸売業" },
  { code: "5221", name: "砂糖・味そ・しょう油卸売業" },
  { code: "5222", name: "酒類卸売業" },
  { code: "5223", name: "乾物卸売業" },
  { code: "5224", name: "菓子・パン類卸売業" },
  { code: "5225", name: "飲料卸売業（別掲を除く）" },
  { code: "5226", name: "茶類卸売業" },
  { code: "5227", name: "牛乳・乳製品卸売業" },
  { code: "5229", name: "その他の食料・飲料卸売業" },
  { code: "5300", name: "主として管理事務を行う本社等" },
  { code: "5308", name: "自家用倉庫" },
  { code: "5309", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "5311", name: "木材・竹材卸売業" },
  { code: "5312", name: "セメント卸売業" },
  { code: "5313", name: "板ガラス卸売業" },
  { code: "5314", name: "建築用金属製品卸売業（建築用金物を除く）" },
  { code: "5319", name: "その他の建築材料卸売業" },
  { code: "5321", name: "塗料卸売業" },
  { code: "5322", name: "プラスチック卸売業" },
  { code: "5329", name: "その他の化学製品卸売業" },
  { code: "5331", name: "石油卸売業" },
  { code: "5332", name: "鉱物卸売業（石油を除く）" },
  { code: "5341", name: "鉄鋼粗製品卸売業" },
  { code: "5342", name: "鉄鋼一次製品卸売業" },
  { code: "5349", name: "その他の鉄鋼製品卸売業" },
  { code: "5351", name: "非鉄金属地金卸売業" },
  { code: "5352", name: "非鉄金属製品卸売業" },
  { code: "5361", name: "空瓶・空缶等空容器卸売業" },
  { code: "5362", name: "鉄スクラップ卸売業" },
  { code: "5363", name: "非鉄金属スクラップ卸売業" },
  { code: "5364", name: "古紙卸売業" },
  { code: "5369", name: "その他の再生資源卸売業" },
  { code: "5400", name: "主として管理事務を行う本社等" },
  { code: "5408", name: "自家用倉庫" },
  { code: "5409", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "5411", name: "農業用機械器具卸売業" },
  { code: "5412", name: "建設機械・鉱山機械卸売業" },
  { code: "5413", name: "金属加工機械卸売業" },
  { code: "5414", name: "事務用機械器具卸売業" },
  { code: "5419", name: "その他の産業機械器具卸売業" },
  { code: "5421", name: "自動車卸売業（二輪自動車を含む）" },
  { code: "5422", name: "自動車部分品・附属品卸売業（中古品を除く）" },
  { code: "5423", name: "自動車中古部品卸売業" },
  { code: "5431", name: "家庭用電気機械器具卸売業" },
  { code: "5432", name: "電気機械器具卸売業（家庭用電気機械器具を除く）" },
  { code: "5491", name: "輸送用機械器具卸売業（自動車を除く）" },
  { code: "5492", name: "計量器・理化学機械器具・光学機械器具等卸売業" },
  { code: "5493", name: "医療用機械器具卸売業（歯科用機械器具を含む）" },
  { code: "5500", name: "主として管理事務を行う本社等" },
  { code: "5508", name: "自家用倉庫" },
  { code: "5509", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "5511", name: "家具・建具卸売業" },
  { code: "5512", name: "荒物卸売業" },
  { code: "5513", name: "畳卸売業" },
  { code: "5514", name: "室内装飾繊維品卸売業" },
  { code: "5515", name: "陶磁器・ガラス器卸売業" },
  { code: "5519", name: "その他のじゅう器卸売業" },
  { code: "5521", name: "医薬品卸売業" },
  { code: "5522", name: "医療用品卸売業" },
  { code: "5523", name: "化粧品卸売業" },
  { code: "5524", name: "合成洗剤卸売業" },
  { code: "5531", name: "紙卸売業" },
  { code: "5532", name: "紙製品卸売業" },
  { code: "5591", name: "金物卸売業" },
  { code: "5592", name: "肥料・飼料卸売業" },
  { code: "5593", name: "スポーツ用品卸売業" },
  { code: "5594", name: "娯楽用品・がん具卸売業" },
  { code: "5595", name: "たばこ卸売業" },
  { code: "5596", name: "ジュエリー製品卸売業" },
  { code: "5597", name: "書籍・雑誌卸売業" },
  { code: "5598", name: "代理商、仲立業" },
  { code: "5599", name: "他に分類されないその他の卸売業" },
  { code: "5600", name: "主として管理事務を行う本社等" },
  { code: "5608", name: "自家用倉庫" },
  { code: "5609", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "5611", name: "百貨店" },
  { code: "5621", name: "総合スーパーマーケット" },
  { code: "5631", name: "コンビニエンスストア" },
  { code: "5641", name: "ドラッグストア" },
  { code: "5651", name: "ホームセンター" },
  { code: "5661", name: "均一価格店" },
  { code: "5699", name: "その他の各種商品小売業" },
  { code: "5700", name: "主として管理事務を行う本社等" },
  { code: "5708", name: "自家用倉庫" },
  { code: "5709", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "5711", name: "呉服・服地小売業" },
  { code: "5712", name: "寝具小売業" },
  { code: "5721", name: "男子服小売業" },
  { code: "5731", name: "婦人服小売業" },
  { code: "5732", name: "子供服小売業" },
  { code: "5741", name: "靴小売業" },
  { code: "5742", name: "履物小売業（靴を除く）" },
  { code: "5791", name: "かばん・袋物小売業" },
  { code: "5792", name: "下着類小売業" },
  { code: "5793", name: "洋品雑貨・小間物小売業" },
  { code: "5799", name: "他に分類されない織物・衣服・身の回り品小売業" },
  { code: "5800", name: "主として管理事務を行う本社等" },
  { code: "5808", name: "自家用倉庫" },
  { code: "5809", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "5811", name: "食料品スーパーマーケット" },
  { code: "5819", name: "その他の各種食料品小売業" },
  { code: "5821", name: "野菜小売業" },
  { code: "5822", name: "果実小売業" },
  { code: "5831", name: "食肉小売業（卵、鳥肉を除く）" },
  { code: "5832", name: "卵・鳥肉小売業" },
  { code: "5841", name: "鮮魚小売業" },
  { code: "5851", name: "酒小売業" },
  { code: "5861", name: "菓子小売業（製造小売）" },
  { code: "5862", name: "菓子小売業（製造小売でないもの）" },
  { code: "5863", name: "パン小売業（製造小売）" },
  { code: "5864", name: "パン小売業（製造小売でないもの）" },
  { code: "5891", name: "牛乳小売業" },
  { code: "5892", name: "飲料小売業（別掲を除く）" },
  { code: "5893", name: "茶類小売業" },
  { code: "5894", name: "料理品小売業" },
  { code: "5895", name: "米穀類小売業" },
  { code: "5896", name: "豆腐・かまぼこ等加工食品小売業" },
  { code: "5897", name: "乾物小売業" },
  { code: "5899", name: "他に分類されない飲食料品小売業" },
  { code: "5900", name: "主として管理事務を行う本社等" },
  { code: "5908", name: "自家用倉庫" },
  { code: "5909", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "5911", name: "自動車（新車）小売業" },
  { code: "5912", name: "中古自動車小売業" },
  { code: "5913", name: "自動車部分品・附属品小売業" },
  { code: "5914", name: "二輪自動車小売業（原動機付自転車を含む）" },
  { code: "5921", name: "自転車小売業" },
  { code: "5931", name: "電気機械器具小売業（中古品を除く）" },
  { code: "5932", name: "電気事務機械器具小売業（中古品を除く）" },
  { code: "5933", name: "中古電気製品小売業" },
  { code: "5939", name: "その他の機械器具小売業" },
  { code: "6000", name: "主として管理事務を行う本社等" },
  { code: "6008", name: "自家用倉庫" },
  { code: "6009", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "6011", name: "家具小売業" },
  { code: "6012", name: "建具小売業" },
  { code: "6013", name: "畳小売業" },
  { code: "6014", name: "宗教用具小売業" },
  { code: "6021", name: "金物小売業" },
  { code: "6022", name: "荒物小売業" },
  { code: "6023", name: "陶磁器・ガラス器小売業" },
  { code: "6029", name: "他に分類されないじゅう器小売業" },
  { code: "6031", name: "医薬品小売業（薬局を除く）" },
  { code: "6032", name: "薬局" },
  { code: "6033", name: "化粧品小売業" },
  { code: "6041", name: "農業用機械器具小売業" },
  { code: "6042", name: "苗・種子小売業" },
  { code: "6043", name: "肥料･飼料小売業" },
  { code: "6051", name: "ガソリンスタンド" },
  { code: "6052", name: "燃料小売業（ガソリンスタンドを除く）" },
  { code: "6061", name: "書籍・雑誌小売業（古本を除く）" },
  { code: "6062", name: "古本小売業" },
  { code: "6063", name: "新聞小売業" },
  { code: "6064", name: "紙・文房具小売業" },
  { code: "6071", name: "スポーツ用品小売業" },
  { code: "6072", name: "がん具・娯楽用品小売業" },
  { code: "6073", name: "楽器小売業" },
  { code: "6081", name: "写真機・写真材料小売業" },
  { code: "6082", name: "時計・眼鏡・光学機械小売業" },
  { code: "6091", name: "たばこ・喫煙具専門小売業" },
  { code: "6092", name: "花・植木小売業" },
  { code: "6093", name: "建築材料小売業" },
  { code: "6094", name: "ジュエリー製品小売業" },
  { code: "6095", name: "ペット・ペット用品小売業" },
  { code: "6096", name: "骨とう品小売業" },
  { code: "6097", name: "中古品小売業（骨とう品を除く）" },
  { code: "6099", name: "他に分類されないその他の小売業" },
  { code: "6100", name: "主として管理事務を行う本社等" },
  { code: "6108", name: "自家用倉庫" },
  { code: "6109", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "6111", name: "無店舗小売業（各種商品小売）" },
  { code: "6112", name: "無店舗小売業（織物･衣服･身の回り品小売）" },
  { code: "6113", name: "無店舗小売業（飲食料品小売）" },
  { code: "6114", name: "無店舗小売業（機械器具小売）" },
  { code: "6119", name: "無店舗小売業（その他の小売）" },
  { code: "6121", name: "自動販売機による小売業" },
  { code: "6199", name: "その他の無店舗小売業" },
  { code: "6200", name: "主として管理事務を行う本社等" },
  { code: "6209", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "6211", name: "中央銀行" },
  { code: "6221", name: "普通銀行" },
  { code: "6222", name: "郵便貯金銀行" },
  { code: "6223", name: "信託銀行" },
  { code: "6229", name: "その他の銀行" },
  { code: "6300", name: "主として管理事務を行う本社等" },
  { code: "6309", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "6311", name: "信用金庫・同連合会" },
  { code: "6312", name: "信用協同組合・同連合会" },
  { code: "6313", name: "商工組合中央金庫" },
  { code: "6314", name: "労働金庫・同連合会" },
  { code: "6321", name: "農林中央金庫" },
  { code: "6322", name: "信用農業協同組合連合会" },
  { code: "6323", name: "信用漁業協同組合連合会、信用水産加工業協同組合連合会" },
  { code: "6324", name: "農業協同組合" },
  { code: "6325", name: "漁業協同組合、水産加工業協同組合" },
  { code: "6400", name: "主として管理事務を行う本社等" },
  { code: "6409", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "6411", name: "消費者向け貸金業" },
  { code: "6412", name: "事業者向け貸金業" },
  { code: "6421", name: "質屋" },
  { code: "6431", name: "クレジットカード業" },
  { code: "6432", name: "割賦金融業" },
  { code: "6491", name: "政府関係金融機関" },
  { code: "6492", name: "住宅専門金融業" },
  { code: "6493", name: "証券金融業" },
  { code: "6499", name: "他に分類されない非預金信用機関" },
  { code: "6500", name: "主として管理事務を行う本社等" },
  { code: "6509", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "6511", name: "金融商品取引業（投資助言・代理・運用業、補助的金融商品取引業を除く）" },
  { code: "6512", name: "投資助言・代理業" },
  { code: "6513", name: "投資運用業" },
  { code: "6514", name: "補助的金融商品取引業" },
  { code: "6521", name: "商品先物取引業" },
  { code: "6522", name: "商品投資顧問業" },
  { code: "6529", name: "その他の商品先物取引業、商品投資顧問業" },
  { code: "6600", name: "主として管理事務を行う本社等" },
  { code: "6609", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "6611", name: "短資業" },
  { code: "6612", name: "手形交換所" },
  { code: "6613", name: "両替業" },
  { code: "6614", name: "信用保証機関" },
  { code: "6615", name: "信用保証再保険機関" },
  { code: "6616", name: "預・貯金等保険機関" },
  { code: "6617", name: "金融商品取引所" },
  { code: "6618", name: "商品取引所" },
  { code: "6619", name: "その他の補助的金融業、金融附帯業" },
  { code: "6621", name: "運用型信託業" },
  { code: "6622", name: "管理型信託業" },
  { code: "6631", name: "金融商品仲介業" },
  { code: "6632", name: "信託契約代理業" },
  { code: "6639", name: "その他の金融代理業" },
  { code: "6700", name: "主として管理事務を行う本社等" },
  { code: "6709", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "6711", name: "生命保険業（郵便保険業、生命保険再保険業を除く）" },
  { code: "6712", name: "郵便保険業" },
  { code: "6713", name: "生命保険再保険業" },
  { code: "6719", name: "その他の生命保険業" },
  { code: "6721", name: "損害保険業（損害保険再保険業を除く）" },
  { code: "6722", name: "損害保険再保険業" },
  { code: "6729", name: "その他の損害保険業" },
  { code: "6731", name: "共済事業（各種災害補償法によるもの）" },
  { code: "6732", name: "共済事業（各種協同組合法等によるもの）" },
  { code: "6733", name: "少額短期保険業" },
  { code: "6741", name: "生命保険媒介業" },
  { code: "6742", name: "損害保険代理業" },
  { code: "6743", name: "共済事業媒介代理業・少額短期保険代理業" },
  { code: "6751", name: "保険料率算出団体" },
  { code: "6752", name: "損害査定業" },
  { code: "6759", name: "その他の保険サービス業" },
  { code: "6800", name: "主として管理事務を行う本社等" },
  { code: "6809", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "6811", name: "建物売買業" },
  { code: "6812", name: "土地売買業" },
  { code: "6821", name: "不動産代理業・仲介業" },
  { code: "6900", name: "主として管理事務を行う本社等" },
  { code: "6909", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "6911", name: "貸事務所業" },
  { code: "6912", name: "土地賃貸業" },
  { code: "6919", name: "その他の不動産賃貸業" },
  { code: "6921", name: "貸家業" },
  { code: "6922", name: "貸間業" },
  { code: "6931", name: "駐車場業" },
  { code: "6941", name: "不動産管理業" },
  { code: "7000", name: "主として管理事務を行う本社等" },
  { code: "7009", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "7011", name: "総合リース業" },
  { code: "7019", name: "その他の各種物品賃貸業" },
  { code: "7021", name: "産業用機械器具賃貸業（建設機械器具を除く）" },
  { code: "7022", name: "建設機械器具賃貸業" },
  { code: "7031", name: "事務用機械器具賃貸業（電子計算機を除く）" },
  { code: "7032", name: "電子計算機・同関連機器賃貸業" },
  { code: "7041", name: "自動車賃貸業" },
  { code: "7051", name: "スポーツ・娯楽用品賃貸業" },
  { code: "7091", name: "映画・演劇用品賃貸業" },
  { code: "7092", name: "音楽・映像記録物賃貸業（別掲を除く）" },
  { code: "7093", name: "貸衣しょう業（別掲を除く）" },
  { code: "7099", name: "他に分類されない物品賃貸業" },
  { code: "7101", name: "管理、補助的経済活動を行う事業所" },
  { code: "7111", name: "理学研究所" },
  { code: "7112", name: "工学研究所" },
  { code: "7113", name: "農学研究所" },
  { code: "7114", name: "医学・薬学研究所" },
  { code: "7121", name: "人文・社会科学研究所" },
  { code: "7201", name: "管理、補助的経済活動を行う事業所" },
  { code: "7211", name: "法律事務所" },
  { code: "7212", name: "特許事務所" },
  { code: "7221", name: "公証人役場、司法書士事務所" },
  { code: "7222", name: "土地家屋調査士事務所" },
  { code: "7231", name: "行政書士事務所" },
  { code: "7241", name: "公認会計士事務所" },
  { code: "7242", name: "税理士事務所" },
  { code: "7251", name: "社会保険労務士事務所" },
  { code: "7261", name: "デザイン業" },
  { code: "7271", name: "著述家業" },
  { code: "7272", name: "芸術家業" },
  { code: "7281", name: "経営コンサルタント業" },
  { code: "7282", name: "純粋持株会社" },
  { code: "7291", name: "興信所" },
  { code: "7292", name: "翻訳業（著述家業を除く）" },
  { code: "7293", name: "通訳業、通訳案内業" },
  { code: "7294", name: "不動産鑑定業" },
  { code: "7299", name: "他に分類されない専門サービス業" },
  { code: "7300", name: "主として管理事務を行う本社等" },
  { code: "7309", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "7311", name: "広告業" },
  { code: "7401", name: "管理、補助的経済活動を行う事業所" },
  { code: "7411", name: "獣医業" },
  { code: "7421", name: "建築設計業" },
  { code: "7422", name: "測量業" },
  { code: "7429", name: "その他の土木建築サービス業" },
  { code: "7431", name: "機械設計業" },
  { code: "7441", name: "商品検査業" },
  { code: "7442", name: "非破壊検査業" },
  { code: "7451", name: "一般計量証明業" },
  { code: "7452", name: "環境計量証明業" },
  { code: "7459", name: "その他の計量証明業" },
  { code: "7461", name: "写真業（商業写真業を除く）" },
  { code: "7462", name: "商業写真業" },
  { code: "7499", name: "その他の技術サービス業" },
  { code: "7500", name: "主として管理事務を行う本社等" },
  { code: "7509", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "7511", name: "旅館、ホテル" },
  { code: "7521", name: "簡易宿所" },
  { code: "7531", name: "下宿業" },
  { code: "7591", name: "会社・団体の宿泊所" },
  { code: "7592", name: "リゾートクラブ" },
  { code: "7599", name: "他に分類されない宿泊業" },
  { code: "7600", name: "主として管理事務を行う本社等" },
  { code: "7609", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "7611", name: "食堂、レストラン（専門料理店を除く）" },
  { code: "7621", name: "日本料理店" },
  { code: "7622", name: "料亭" },
  { code: "7623", name: "中華料理店" },
  { code: "7624", name: "ラーメン店" },
  { code: "7625", name: "焼肉店" },
  { code: "7629", name: "その他の専門料理店" },
  { code: "7631", name: "そば・うどん店" },
  { code: "7641", name: "すし店" },
  { code: "7651", name: "酒場、ビヤホール" },
  { code: "7661", name: "バー、キャバレー、ナイトクラブ" },
  { code: "7671", name: "喫茶店" },
  { code: "7691", name: "ハンバーガー店" },
  { code: "7692", name: "お好み焼き・焼きそば・たこ焼店" },
  { code: "7699", name: "他に分類されない飲食店" },
  { code: "7700", name: "主として管理事務を行う本社等" },
  { code: "7709", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "7711", name: "持ち帰り飲食サービス業" },
  { code: "7721", name: "配達飲食サービス業" },
  { code: "7731", name: "施設給食業" },
  { code: "7800", name: "主として管理事務を行う本社等" },
  { code: "7809", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "7811", name: "普通洗濯業" },
  { code: "7812", name: "洗濯物取次業" },
  { code: "7813", name: "リネンサプライ業" },
  { code: "7821", name: "理容業" },
  { code: "7831", name: "美容業" },
  { code: "7841", name: "一般公衆浴場業" },
  { code: "7851", name: "その他の公衆浴場業" },
  { code: "7891", name: "洗張・染物業" },
  { code: "7892", name: "エステティック業" },
  { code: "7893", name: "リラクゼーション業（手技を用いるもので医業類似行為を除く）" },
  { code: "7894", name: "ネイルサービス業" },
  { code: "7899", name: "他に分類されない洗濯・理容・美容・浴場業" },
  { code: "7900", name: "主として管理事務を行う本社等" },
  { code: "7909", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "7911", name: "旅行業(旅行業者代理業を除く)" },
  { code: "7912", name: "旅行業者代理業" },
  { code: "7921", name: "家事サービス業（住込みのもの）" },
  { code: "7922", name: "家事サービス業（住込みでないもの）" },
  { code: "7931", name: "衣服裁縫修理業" },
  { code: "7941", name: "物品預り業" },
  { code: "7951", name: "火葬業" },
  { code: "7952", name: "墓地管理業" },
  { code: "7961", name: "葬儀業" },
  { code: "7962", name: "結婚式場業" },
  { code: "7963", name: "冠婚葬祭互助会" },
  { code: "7991", name: "食品賃加工業" },
  { code: "7992", name: "結婚相談業、結婚式場紹介業" },
  { code: "7993", name: "写真プリント、現像・焼付業" },
  { code: "7999", name: "他に分類されないその他の生活関連サービス業" },
  { code: "8000", name: "主として管理事務を行う本社等" },
  { code: "8009", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "8011", name: "映画館" },
  { code: "8021", name: "劇場" },
  { code: "8022", name: "興行場" },
  { code: "8023", name: "劇団" },
  { code: "8024", name: "楽団、舞踏団" },
  { code: "8025", name: "演芸・スポーツ等興行団" },
  { code: "8031", name: "競輪場" },
  { code: "8032", name: "競馬場" },
  { code: "8033", name: "自動車・モーターボートの競走場" },
  { code: "8034", name: "競輪競技団" },
  { code: "8035", name: "競馬競技団" },
  { code: "8036", name: "自動車・モーターボートの競技団" },
  { code: "8041", name: "スポーツ施設提供業（別掲を除く）" },
  { code: "8042", name: "体育館" },
  { code: "8043", name: "ゴルフ場" },
  { code: "8044", name: "ゴルフ練習場" },
  { code: "8045", name: "ボウリング場" },
  { code: "8046", name: "テニス場" },
  { code: "8047", name: "バッティング・テニス練習場" },
  { code: "8048", name: "フィットネスクラブ" },
  { code: "8051", name: "公園" },
  { code: "8052", name: "遊園地（テーマパークを除く）" },
  { code: "8053", name: "テーマパーク" },
  { code: "8061", name: "ビリヤード場" },
  { code: "8062", name: "囲碁・将棋所" },
  { code: "8063", name: "マージャンクラブ" },
  { code: "8064", name: "パチンコホール" },
  { code: "8065", name: "ゲームセンター" },
  { code: "8069", name: "その他の遊戯場" },
  { code: "8091", name: "ダンスホール" },
  { code: "8092", name: "マリーナ業" },
  { code: "8093", name: "遊漁船業" },
  { code: "8094", name: "芸ぎ業" },
  { code: "8095", name: "カラオケボックス業" },
  { code: "8096", name: "娯楽に附帯するサービス業" },
  { code: "8099", name: "他に分類されない娯楽業" },
  { code: "8101", name: "管理、補助的経済活動を行う事業所" },
  { code: "8111", name: "幼稚園" },
  { code: "8121", name: "小学校" },
  { code: "8131", name: "中学校" },
  { code: "8132", name: "義務教育学校" },
  { code: "8141", name: "高等学校" },
  { code: "8142", name: "中等教育学校" },
  { code: "8151", name: "特別支援学校" },
  { code: "8161", name: "大学" },
  { code: "8162", name: "短期大学" },
  { code: "8163", name: "高等専門学校" },
  { code: "8171", name: "専修学校" },
  { code: "8172", name: "各種学校" },
  { code: "8181", name: "高等教育機関の支援機関" },
  { code: "8191", name: "幼保連携型認定こども園" },
  { code: "8200", name: "主として管理事務を行う本社等" },
  { code: "8209", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "8211", name: "公民館" },
  { code: "8212", name: "図書館" },
  { code: "8213", name: "博物館、美術館" },
  { code: "8214", name: "動物園、植物園、水族館" },
  { code: "8215", name: "青少年教育施設" },
  { code: "8216", name: "社会通信教育" },
  { code: "8219", name: "その他の社会教育" },
  { code: "8221", name: "職員教育施設・支援業" },
  { code: "8222", name: "職業訓練施設" },
  { code: "8229", name: "その他の職業・教育支援施設" },
  { code: "8231", name: "学習塾" },
  { code: "8241", name: "音楽教授業" },
  { code: "8242", name: "書道教授業" },
  { code: "8243", name: "生花・茶道教授業" },
  { code: "8244", name: "そろばん教授業" },
  { code: "8245", name: "外国語会話教授業" },
  { code: "8246", name: "スポーツ・健康教授業" },
  { code: "8249", name: "その他の教養・技能教授業" },
  { code: "8299", name: "他に分類されない教育、学習支援業" },
  { code: "8300", name: "主として管理事務を行う本社等" },
  { code: "8309", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "8311", name: "一般病院" },
  { code: "8312", name: "精神科病院" },
  { code: "8321", name: "有床診療所" },
  { code: "8322", name: "無床診療所" },
  { code: "8331", name: "歯科診療所" },
  { code: "8341", name: "助産所" },
  { code: "8342", name: "看護業" },
  { code: "8351", name: "あん摩ﾏｯｻｰｼﾞ指圧師・はり師・きゅう師・柔道整復師の施術所" },
  { code: "8352", name: "療術業" },
  { code: "8361", name: "歯科技工所" },
  { code: "8369", name: "その他の医療に附帯するサービス業" },
  { code: "8400", name: "主として管理事務を行う本社等" },
  { code: "8409", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "8411", name: "保健所" },
  { code: "8421", name: "結核健康相談施設" },
  { code: "8422", name: "精神保健相談施設" },
  { code: "8423", name: "母子健康相談施設" },
  { code: "8429", name: "その他の健康相談施設" },
  { code: "8491", name: "検疫所（動物検疫所、植物防疫所を除く）" },
  { code: "8492", name: "検査業" },
  { code: "8499", name: "他に分類されない保健衛生" },
  { code: "8500", name: "主として管理事務を行う本社等" },
  { code: "8509", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "8511", name: "社会保険事業団体" },
  { code: "8521", name: "福祉事務所" },
  { code: "8531", name: "保育所" },
  { code: "8539", name: "その他の児童福祉事業" },
  { code: "8541", name: "特別養護老人ホーム" },
  { code: "8542", name: "介護老人保健施設" },
  { code: "8543", name: "介護医療院" },
  { code: "8544", name: "通所・短期入所介護事業" },
  { code: "8545", name: "訪問介護事業" },
  { code: "8546", name: "認知症老人グループホーム" },
  { code: "8547", name: "有料老人ホーム" },
  { code: "8549", name: "その他の老人福祉・介護事業" },
  { code: "8551", name: "居住支援事業" },
  { code: "8559", name: "その他の障害者福祉事業" },
  { code: "8591", name: "更生保護事業" },
  { code: "8599", name: "他に分類されない社会保険・社会福祉・介護事業" },
  { code: "8601", name: "管理、補助的経済活動を行う事業所" },
  { code: "8611", name: "郵便局" },
  { code: "8621", name: "簡易郵便局" },
  { code: "8629", name: "その他の郵便局受託業" },
  { code: "8701", name: "管理、補助的経済活動を行う事業所" },
  { code: "8711", name: "農業協同組合（他に分類されないもの）" },
  { code: "8712", name: "漁業協同組合（他に分類されないもの）" },
  { code: "8713", name: "水産加工業協同組合（他に分類されないもの）" },
  { code: "8714", name: "森林組合（他に分類されないもの）" },
  { code: "8721", name: "事業協同組合（他に分類されないもの）" },
  { code: "8800", name: "主として管理事務を行う本社等" },
  { code: "8809", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "8811", name: "し尿収集運搬業" },
  { code: "8812", name: "し尿処分業" },
  { code: "8813", name: "浄化槽清掃業" },
  { code: "8814", name: "浄化槽保守点検業" },
  { code: "8815", name: "ごみ収集運搬業" },
  { code: "8816", name: "ごみ処分業" },
  { code: "8817", name: "清掃事務所" },
  { code: "8821", name: "産業廃棄物収集運搬業" },
  { code: "8822", name: "産業廃棄物処分業" },
  { code: "8823", name: "特別管理産業廃棄物収集運搬業" },
  { code: "8824", name: "特別管理産業廃棄物処分業" },
  { code: "8891", name: "死亡獣畜取扱業" },
  { code: "8899", name: "他に分類されない廃棄物処理業" },
  { code: "8901", name: "管理、補助的経済活動を行う事業所" },
  { code: "8911", name: "自動車一般整備業" },
  { code: "8919", name: "その他の自動車整備業" },
  { code: "9000", name: "主として管理事務を行う本社等" },
  { code: "9009", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "9011", name: "一般機械修理業（建設・鉱山機械を除く）" },
  { code: "9012", name: "建設・鉱山機械整備業" },
  { code: "9021", name: "電気機械器具修理業" },
  { code: "9031", name: "表具業" },
  { code: "9091", name: "家具修理業" },
  { code: "9092", name: "時計修理業" },
  { code: "9093", name: "履物修理業" },
  { code: "9094", name: "かじ業" },
  { code: "9099", name: "他に分類されない修理業" },
  { code: "9100", name: "主として管理事務を行う本社等" },
  { code: "9109", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "9111", name: "職業紹介業" },
  { code: "9121", name: "労働者派遣業" },
  { code: "9200", name: "主として管理事務を行う本社等" },
  { code: "9209", name: "その他の管理、補助的経済活動を行う事業所" },
  { code: "9211", name: "速記・ワープロ入力業" },
  { code: "9212", name: "複写業" },
  { code: "9221", name: "ビルメンテナンス業" },
  { code: "9229", name: "その他の建物等維持管理業" },
  { code: "9231", name: "警備業" },
  { code: "9291", name: "ディスプレイ業" },
  { code: "9292", name: "産業用設備洗浄業" },
  { code: "9293", name: "看板書き業" },
  { code: "9294", name: "コールセンター業" },
  { code: "9295", name: "ペストコントロール業" },
  { code: "9299", name: "他に分類されないその他の事業サービス業" },
  { code: "9311", name: "実業団体" },
  { code: "9312", name: "同業団体" },
  { code: "9321", name: "労働団体" },
  { code: "9331", name: "学術団体" },
  { code: "9332", name: "文化団体" },
  { code: "9341", name: "政治団体" },
  { code: "9399", name: "他に分類されない非営利的団体" },
  { code: "9411", name: "神社、神道教会" },
  { code: "9412", name: "教派事務所" },
  { code: "9421", name: "寺院、仏教教会" },
  { code: "9422", name: "宗派事務所" },
  { code: "9431", name: "キリスト教教会、修道院" },
  { code: "9432", name: "教団事務所" },
  { code: "9491", name: "その他の宗教の教会" },
  { code: "9499", name: "その他の宗教の教団事務所" },
  { code: "9501", name: "管理、補助的経済活動を行う事業所" },
  { code: "9511", name: "集会場" },
  { code: "9521", name: "と畜場" },
  { code: "9599", name: "他に分類されないサービス業" },
  { code: "9611", name: "外国公館" },
  { code: "9699", name: "その他の外国公務" },
  { code: "9711", name: "立法機関" },
  { code: "9721", name: "司法機関" },
  { code: "9731", name: "行政機関" },
  { code: "9811", name: "都道府県の機関" },
  { code: "9821", name: "市町村の機関" },
  { code: "9999", name: "分類不能の産業" },
];
